import React, {useContext, useState} from "react";
import {Box, Checkbox, NumberField} from "@mbank-design/design-system/components";
import {AdditionalSupportContext} from "./AdditionalSupportContext";

export default function BanquetSection() {
    const [checked, setChecked] = useState(false);
    const {showBanquet, banquetLocation, banquetCount, onBanquetCountChange} = useContext(AdditionalSupportContext);

    const onValueChange = (value: string) => {
        onBanquetCountChange!(parseInt(value, 10));
    }

    const onCheckedChange = () => {
        if (checked)
            onBanquetCountChange!(0);
        else
            onBanquetCountChange!(1);

        setChecked(!checked);
    }

    if (showBanquet) {
        return (
            <>
                <Checkbox checked={checked} onChange={onCheckedChange} label={ banquetLocation ? "reception: " + banquetLocation : "reception" } />
                {checked ? (
                    <Box maxWidth={300}>
                        <NumberField value={banquetCount} onChange={onValueChange} label={"how many guests?"} isStepperVisible />
                    </Box>
                ) : (<></>)}
            </>
        )
    } else return <></>
    
}